import CookiesModel from './cookies-model';
import CookiesView from './cookies-view';
import * as UIService from '../../services/ui-service';

export default class CookiesPresenter {
  constructor(view, appInterface) {
    this.model = new CookiesModel();
    this.view = view || new CookiesView();
    this.appInterface = appInterface || {};
  }

  async init() {
    this.renderPageContent();
    this.setupEventListeners();
  }

  renderPageContent() {
    const pageData = this.model.getPageData();
    const policyContent = this.model.getPolicyContent();
    
    this.view.renderPageHeader(pageData);
    this.view.renderContent(policyContent);
    
    this.appInterface.reinitTooltips();
  }

  setupEventListeners() {
    this.view.setupBackButtonEventListener(() => this.handleBackClick());
  }

  handleBackClick() {
    this.appInterface.navigateBack();
  }

  cleanup() {
    this.view.cleanup();
  }
}